"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Button_styles_1 = __importDefault(require("./Button.styles"));
var Button = function (_a) {
    var className = _a.className, _b = _a.type, type = _b === void 0 ? 'button' : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, onClick = _a.onClick, children = _a.children;
    return (react_1.default.createElement(Button_styles_1.default, { className: className, type: type, onClick: onClick, disabled: disabled }, children));
};
exports.default = Button;
